module.exports = __webpack_public_path__ + "static/photo-fbd446bae5370d5fad90e57883841f9a.jpg";